var exports = {
  "a": "Box__rBeO-d",
};

module.exports = exports;
